import React, { useState } from "react";
import axios from "axios";

const EnquiryForm = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    // e.preventDefault();
    // try {
    //   await axios.post("http://localhost:8000/api/enquiry", form);
    //   setStatus("Enquiry submitted successfully!");
    //   setForm({ name: "", email: "", message: "" });
    // } catch (error) {
    //   setStatus("Submission failed.");
    // }
  };

  return (
    <form onSubmit={handleSubmit}>
      <input name="name" value={form.name} onChange={handleChange} placeholder="Name" required />
      <input name="email" value={form.email} onChange={handleChange} placeholder="Email" required />
      <textarea name="message" value={form.message} onChange={handleChange} placeholder="Message" required />
      <button type="submit">Send Enquiry</button>
      {status && <p>{status}</p>}
    </form>
  );
};

export default EnquiryForm;
